export default {
  props: {
    addingItem: {
      type: Boolean,
      default: false,
    },
    handleChangeListItem: {
      type: Function,
      required: true,
    },
    index: {
      type: Number,
      default: undefined,
    },
    listItem: {
      type: Object,
      required: true,
    },
    namePlaceholder: {
      default: 'Attribute Name',
      type: String,
    },
    nameReadOnly: {
      type: Boolean,
      default: false,
    },
    nameValidation: {
      type: String,
      default: 'alpha_num|max:32|required',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    valueMaxLengthValidation: {
      type: String,
      default: '1,024',
    },
    valueReadOnly: {
      type: Boolean,
      default: false,
    },
    valuePlaceholder: {
      type: String,
      default: 'Attribute Value',
    },
    valueValidation: {
      type: String,
      default: 'max:1024|required',
    },
  },

  computed: {
    scope() {
      return this.listItem._id || this.listItem.tempId;
    },

    /**
     * Create a unique name for the attribute name field so errors in this
     * field can be uniquely identified.
     */
    nameAttributeName() {
      return `attribute-${this.scope}-name`;
    },

    /**
     * Create a unique name for the attribute value field so errors in this
     * field can be uniquely identified.
     */
    valueAttributeName() {
      return `attribute-${this.scope}-value`;
    },
  },

  /**
   * Use field specific custom messages in vee-validate so that the unique
   * input names are not used in the error messages.
   * @see https://baianat.github.io/vee-validate/guide/messages.html#field-specific-custom-messages
   */
  mounted() {
    this.handleMounted();
  },

  methods: {
    getNameAttributeChild() {
      return this.$children[0];
    },

    handleMounted() {
      const vValidateDict = {
        custom: {
          [this.nameAttributeName]: {
            alpha_num: '* The attribute name field may only contain alpha numeric characters.',
            max: '* 32 character limit.',
            required: '* The attribute name field is required.',
          },
          [this.valueAttributeName]: {
            max: `* ${this.valueMaxLengthValidation} character limit.`,
            numeric: 'Value format must be a number.',
            required: '* The attribute value field is required.',
          },
        },
      };

      this.$validator.localize('en', vValidateDict);
    },

    isReadOnly(value) {
      return value || this.readonly;
    },
  },
};
